module.exports = __webpack_public_path__ + "static/media/facebook.52ae7932.svg";